import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { I18n } from 'react-redux-i18n';
import request from 'superagent';
import { formatDate, DATE_WITH_TIME_FORMAT } from '@utils/date';
import { addSuccess } from '../../../actions/utils';
import { needsTeacher } from '../../utils/authHoc';
import StatusBadge from './StatusBadge';
import './homework.scss';

class HomeworkList extends React.Component {
  state = {
    items: [],
    pending: 0,
    courses: [],
    q: '',
    status: '',
    course: '',
  };

  componentDidMount() {
    this.loadCourses();
    this.load();
  }

  loadCourses = () => {
    request.get('/homework/courses').end((err, res) => {
      if (!err) this.setState({ courses: res.body || [] });
    });
  };

  load = () => {
    const { q, status, course } = this.state;
    request
      .get('/homework')
      .query({ q, status, course })
      .end((err, res) => {
        if (err) {
          this.setState({ items: [], pending: 0 });
          return;
        }
        this.setState({
          items: (res.body && res.body.items) || [],
          pending: (res.body && res.body.pending) || 0,
        });
      });
  };

  copy = (event, url) => {
    event.preventDefault();
    event.stopPropagation();
    const notify = () => this.props.addSuccess(I18n.t('homework.linkCopied'));
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(notify).catch(notify);
    } else {
      notify();
    }
  };

  render() {
    const { user } = this.props;
    const { items, pending, courses, q, status, course } = this.state;
    const isAdmin = user && user.group === 'admin';

    return (
      <div className="hw">
        <div className="hw-head">
          <h1>
            {I18n.t(isAdmin ? 'homework.allAssignments' : 'homework.myAssignments')}
          </h1>
          {pending > 0 && (
            <button
              type="button"
              className="hw-badge"
              onClick={() => this.setState({ status: 'answered' }, this.load)}
            >
              {I18n.t('homework.pending', { count: pending })}
            </button>
          )}
          <span className="hw-spacer" />
          {isAdmin && (
            <a className="hw-btn hw-btn--ghost hw-btn--sm" href="/homework/export.csv">
              {I18n.t('homework.exportCsv')}
            </a>
          )}
          <Link className="hw-btn" to="/i/gui/homework/new">
            {I18n.t('homework.newAssignment')}
          </Link>
        </div>
        <p className="hw-muted">{I18n.t('homework.hint')}</p>

        <div className="hw-card">
          <div className="hw-filters">
            <input
              type="search"
              placeholder={I18n.t('homework.searchStudent')}
              value={q}
              onChange={e => this.setState({ q: e.target.value })}
            />
            <select
              value={status}
              onChange={e => this.setState({ status: e.target.value })}
            >
              <option value="">{I18n.t('homework.allStatuses')}</option>
              <option value="assigned">{I18n.t('homework.status.assigned')}</option>
              <option value="answered">{I18n.t('homework.status.answered')}</option>
              <option value="returned">{I18n.t('homework.status.returned')}</option>
              <option value="checked">{I18n.t('homework.status.checked')}</option>
            </select>
            <select
              value={course}
              onChange={e => this.setState({ course: e.target.value })}
            >
              <option value="">{I18n.t('homework.allCourses')}</option>
              {courses.map(name => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
            <button type="button" className="hw-btn hw-btn--ghost" onClick={this.load}>
              {I18n.t('homework.find')}
            </button>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="hw-card">
            <p>{I18n.t('homework.empty')}</p>
            <Link className="hw-btn" to="/i/gui/homework/new">
              {I18n.t('homework.createFirst')}
            </Link>
          </div>
        ) : (
          <table className="hw-table">
            <thead>
              <tr>
                <th>{I18n.t('homework.created')}</th>
                <th>{I18n.t('homework.course')}</th>
                <th>{I18n.t('homework.lesson')}</th>
                <th>{I18n.t('homework.student')}</th>
                {isAdmin && <th>{I18n.t('homework.teacher')}</th>}
                <th>{I18n.t('homework.statusLabel')}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map(row => (
                <tr
                  key={row.id}
                  onClick={() => browserHistory.push(`/i/gui/homework/${row.id}`)}
                >
                  <td>{formatDate(row.createdAt, DATE_WITH_TIME_FORMAT)}</td>
                  <td>
                    <span className="hw-tag">{row.courseName}</span>
                  </td>
                  <td>
                    {row.lessonNo ? I18n.t('homework.lessonNo', { n: row.lessonNo }) : ''}
                    {row.topic ? ` ${row.topic}` : ''}
                  </td>
                  <td>
                    <b>{row.studentName}</b>
                  </td>
                  {isAdmin && <td>{row.teacherName}</td>}
                  <td>
                    <StatusBadge status={row.status} />
                  </td>
                  <td>
                    <Link
                      className="hw-btn hw-btn--ghost hw-btn--sm"
                      to={`/i/gui/homework/${row.id}`}
                      onClick={e => e.stopPropagation()}
                    >
                      {I18n.t('homework.open')}
                    </Link>{' '}
                    <button
                      type="button"
                      className="hw-btn hw-btn--ghost hw-btn--sm"
                      onClick={e => this.copy(e, row.publicUrl)}
                    >
                      {I18n.t('homework.link')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default compose(
  needsTeacher,
  connect(
    state => ({ user: state.auth.user, locale: state.i18n.locale }),
    dispatch => ({
      addSuccess: message => dispatch(addSuccess(message)),
    })
  )
)(HomeworkList);
